module.exports = (number) => {
  if (number === null || number === undefined) return "";

  // Remove all non-digit characters
  const numericValue = String(number).replace(/\D/g, "");

  if (numericValue === "0") return "0";
  if (numericValue === "") return "";

  return Number(numericValue).toLocaleString();
};
